"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptAVendorEmailCompletionLinkType = exports.PromptAVendorEmailSendType = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * Prompt-a-Vendor email send type.
 */
exports.PromptAVendorEmailSendType = (0, type_utils_1.makeEnum)({
    /** Send a single email encapsulating all profiles, i.e. at the RequestDataSilo level. */
    PerDsr: 'PER_DSR',
    /** Send an email for all DSRs, that the vendor has not been notified of yet. */
    CrossDsr: 'CROSS_DSR',
});
/**
 * Prompt-a-Vendor Email Completion link type.
 */
exports.PromptAVendorEmailCompletionLinkType = (0, type_utils_1.makeEnum)({
    /** Present a link that requires a user logged into Transcend. */
    LoggedInUser: 'LOGGED_IN_USER',
    /**
     * Present a link that allows an external, unauthenticated user
     * to access the Bulk Requests UI.
     */
    UnauthenticatedExternalUser: 'UNAUTHENTICATED_EXTERNAL_USER',
    /**
     * Send no completion fulfillment link, and mark each datapoint
     * as resolved, once the email is sent.
     */
    NoLinkMarkDatapointAsResolved: 'NO_LINK_MARK_DATAPOINT_AS_RESOLVED',
});
//# sourceMappingURL=promptAVendor.js.map